const nestPath = process.env.REACT_APP_NEST_API_URL;
const AUTH_SMS_BASE_PATH = `${nestPath}/v3/auth/sms`;

export const smsVerificationPath = {
    sendSms: `${AUTH_SMS_BASE_PATH}/send`,
    // getStatus: `${AUTH_SMS_BASE_PATH}/status`, // 문자 발송 상태 확인
    matchCode: `${AUTH_SMS_BASE_PATH}/match`, // 문자 인증 코드 확인
    loginViaSms: `${AUTH_SMS_BASE_PATH}/login/app`, // 문자 인증 로그인
    findId: `${nestPath}/auth/sms/id`, // 문자 인증 아이디 찾기
    initPassword: `${nestPath}/auth/sms/password/init`, // 문자 인증 비밀번호 초기화
};

export const smsJoinPath = {
    joinViaSms: `${nestPath}/v3/user/join/app`,
};
